import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Select from 'react-select';
import { FormHelperText } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { getGermanStatesList } from '../../../services/accreditation-forms-service';
import store from '../../../store';

const useInputStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
    maxWidth: theme.custom.inputs.maxWidth,
    marginBottom: theme.spacing(5),
  },
}));

const InputMultiSelect = (props) => {
  const { field, form, label, required, hint, ...restProps } = props;
  const { errors, touched } = form;
  const { t } = useTranslation();
  // const dispatch = useDispatch();
  const [options, setOptions] = useState([]);
  const { tenantId, token } = store.getState().formSession;

  useEffect(() => {
    // getEventsList();
    getGermanStates();
  }, []);

  const isError = touched[field.name] && errors?.[field.name];

  const classes = useInputStyles();

  const labelToDisplay = `${t(label)} ${required ? '*' : ':'}`;

  const shouldDisplayError = () => touched[field.name] && !!errors[field.name];

  // const getEventsList = async () => {
  //   const events = await getApiEventsList(tenantId, token);
  //   if (events) {
  //     const eventsOptions = events.map((event) => {
  //       return { label: event.eventName, value: event.eventId };
  //     });
  //     dispatch(allActions.formSessionActions.setFormSessionEventsList(eventsOptions));

  //     setEventsList(eventsOptions);
  //   }
  // };

  const getGermanStates = async () => {
    const states = await getGermanStatesList(tenantId, token);
    if (states) {
      const stateOptions = states.map((item) => {
        return { label: item, value: item };
      });
      // dispatch(allActions.formSessionActions.setFormSessionEventsList(eventsOptions));

      setOptions(stateOptions);
    }
  };

  const onChange = (option) => {
    form.setFieldValue(
      field.name,
      option.map((item) => item.value),
    );
  };

  // const getValue = () => {
  //   if (eventsList) {
  //     return eventsList.filter((option) => field.value.indexOf(option.value) >= 0);
  //   }
  //   return [];
  // };

  const getValue = () => {
    if (options) {
      return options.filter((option) => field.value.indexOf(option.value) >= 0);
    }
    return [];
  };

  return (
    <div className={classes.wrapper}>
      <span style={{ 'font-size': 'small' }}>{labelToDisplay}</span>
      <Select
        {...restProps}
        placeholder="Select"
        name={field.name}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          placeholder: (base) => ({
            ...base,
            ...(isError ? { color: '#f44336' } : { color: '#000000' }),
          }),
          control: (base) => ({
            ...base,

            ...(isError && { 'border-color': '#f44336' }),
            ...(isError && {
              '&:hover': {
                'border-color': '#f44336',
              },
            }),
            ...(isError && {
              '&:focus-visible': {
                'border-color': '#f44336',
              },
            }),
          }),
        }}
        menuPortalTarget={document.body}
        isMulti
        options={options}
        value={getValue()}
        onChange={onChange}
        closeMenuOnSelect={false}
        required
      />
      <FormHelperText variant="filled" required error={shouldDisplayError()} margin="dense">
        {shouldDisplayError() ? errors[field.name] : hint}
      </FormHelperText>
    </div>
  );
};

export default InputMultiSelect;
